import React from "react";
import { Button } from "components";
import clsx from "clsx";

export const StepButtons = ({ nextStep, prevStep, initialTabIndex = 0 }) => (
	<div className={clsx("d-flex", "flex-row-reverse", "mt-auto")}>
		{nextStep && (
			<Button tabIndex={initialTabIndex} type="submit" isPrimary={true}>
				next step
			</Button>
		)}
		{prevStep && (
			<Button
				tabIndex={initialTabIndex + 1}
				type="button"
				onClick={prevStep}
				className="mr-4"
			>
				previous step
			</Button>
		)}
	</div>
);
